{
  "it": {
    "button": {
      "actions": {
        "add": "Aggiungi",
        "cancel": "Annulla",
        "close": "Chiudi",
        "copyEmail": "Copia email",
        "create": "Crea",
        "delete": "Elimina",
        "display": "Visualizza",
        "edit": "Modifica",
        "hide": "Nascondi",
        "loading": "Caricamento",
        "more": "Altre azioni",
        "move": "Sposta",
        "move_down": "Sposta giù",
        "move_up": "Sposta su",
        "no": "No",
        "reactivateEmailAddress": "Riattiva indirizzo email",
        "reset": "Reimposta",
        "save": "Salva",
        "save_changes": "Salva modifiche",
        "save_message": "Salva messaggio",
        "saving": "Salvataggio",
        "share": "Condividi",
        "startTour": "Avvia tour",
        "uploadingDocuments": "Caricamento documenti",
        "yes": "Sì"
      }
    }
  }
}
